<script setup lang="ts">
import guy from '@/assets/main/guy.webp'
</script>

<template>
    <section class="relative z-20 mx-auto flex max-w-[1224px] flex-col justify-between gap-6 px-4 pt-40 md:flex-row lg:pt-36">
        <h1 class="w-full max-w-[679px] text-3xl/snug font-bold text-white lg:mt-24 lg:text-4xl/snug xl:text-5xl/snug">
            {{ $t('32 years connecting great leaders in logistics and supply chain') }}
        </h1>
        <div class="flex-1 self-end">
            <img :src="guy" alt="" class="w-full" width="521" height="610" />
        </div>
    </section>
</template>
